<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ headerText }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 py-7">
        <div class="row flex-grow-0 flex-shrink-0" v-if="serverData">
          <!--          <div class="col-12 py-0 col-md-6 col-md-4" v-if="!isClient">-->
          <div class="col-12 py-0">
            <v-text-field
              v-model="formData.title"
              :label="$t('title')"
              clearable
              outlined
              dense
              :error-messages="titleErrors"
              @blur="$v.formData.title.$touch()"
            />
          </div>

          <div class="col-12 py-0">
            <v-autocomplete
              v-model="formData.receiver_type"
              :label="$t('receiver_type')"
              item-text="label"
              item-value="value"
              :items="serverData.receiver_types"
              clearable
              outlined
              dense
              :error-messages="receiver_typeErrors"
              @blur="$v.formData.receiver_type.$touch()"
            />
          </div>

          <!--          <div-->
          <!--            class="col-12 py-0"-->
          <!--            v-if="-->
          <!--              formData.receiver_type !== 'end_customer' &&-->
          <!--              formData.receiver_type !== 'self'-->
          <!--            "-->
          <!--          > -->
          <div
            class="col-12 py-0"
            v-if="
              receiverDetails?.list?.length && formData.receiver_type !== 'self'
            "
          >
            <v-autocomplete
              v-model="formData.receiver_values"
              :label="receiverDetails.label"
              :items="receiverDetails.list"
              item-text="text"
              item-value="index"
              multiple
              small-chips
              deletable-chips
              clearable
              outlined
              dense
              :error-messages="receiver_valuesErrors"
              @blur="$v.formData.receiver_values.$touch()"
            />
            <!--            :multiple="receiverDetails.isMultiple"-->
            <!--            :small-chips="receiverDetails.isMultiple"-->
            <!--            :deletable-chips="receiverDetails.isMultiple"-->
          </div>

          <div class="col-12 py-0 min-h-65px">
            <div
              class="ms-field"
              :class="{
                'ms-field--active': ccFocused || formData.cc_emails?.length,
              }"
            >
              <label class="ms-field__label">{{ $t("cc") }}</label>
              <Multiselect
                v-model="formData.cc_emails"
                class="custom__multiselect"
                :tag-placeholder="$t('add_this_as_new_email')"
                placeholder=""
                :options="ccOptions"
                label="name"
                track-by="code"
                openDirection="bottom"
                :multiple="true"
                :taggable="true"
                ref="cc_emails"
                @tag="(query) => addTag(query)"
                @open="ccFocused = true"
                @close="ccFocused = false"
              >
                <template #clear>
                  <div
                    class="multiselect__clear"
                    v-if="formData.cc_emails?.length"
                    @click.prevent.stop="() => resetCCEmails(1)"
                  ></div>
                </template>
              </Multiselect>
            </div>
          </div>

          <div class="col-12 py-0 min-h-65px">
            <div
              class="ms-field"
              :class="{
                'ms-field--active': bccFocused || formData.bcc_emails?.length,
              }"
            >
              <label class="ms-field__label">{{ $t("bcc") }}</label>
              <Multiselect
                v-model="formData.bcc_emails"
                class="custom__multiselect"
                :tag-placeholder="$t('add_this_as_new_email')"
                placeholder=""
                :options="bccOptions"
                label="name"
                track-by="code"
                openDirection="bottom"
                :multiple="true"
                :taggable="true"
                ref="bcc_emails"
                @tag="(query) => addTag(query, 'bcc_emails', 'bccOptions')"
                @open="bccFocused = true"
                @close="bccFocused = false"
              >
                <template #clear>
                  <div
                    class="multiselect__clear"
                    v-if="formData.cc_emails?.length"
                    @click.prevent.stop="() => resetCCEmails(1)"
                  ></div>
                </template>
              </Multiselect>
            </div>
            <!--            <Multiselect-->
            <!--              v-model="formData.bcc_emails"-->
            <!--              class="custom__multiselect"-->
            <!--              :tag-placeholder="$t('add_this_as_new_email')"-->
            <!--              :placeholder="$t('bcc')"-->
            <!--              :options="bccOptions"-->
            <!--              label="name"-->
            <!--              track-by="code"-->
            <!--              openDirection="bottom"-->
            <!--              :multiple="true"-->
            <!--              :taggable="true"-->
            <!--              ref="bcc_emails"-->
            <!--              @tag="(query) => addTag(query, 'bcc_emails', 'bccOptions')"-->
            <!--            >-->
            <!--              <template #clear>-->
            <!--                <div-->
            <!--                  class="multiselect__clear"-->
            <!--                  v-if="formData.bcc_emails?.length"-->
            <!--                  @click.prevent.stop="() => resetCCEmails(2)"-->
            <!--                ></div>-->
            <!--              </template>-->
            <!--            </Multiselect>-->
          </div>

          <div class="col-12 py-0 col-md-6">
            <v-autocomplete
              v-model="formData.action_type_id"
              :label="$t('action_type')"
              :items="receiverDetails?.action_types"
              item-text="text"
              item-value="index"
              clearable
              outlined
              dense
              :error-messages="action_type_idErrors"
              @blur="$v.formData.action_type_id.$touch()"
            />
          </div>

          <div
            v-if="
              formData.action_type_id === 2 || formData.action_type_id === 3
            "
            class="col-12 py-0 col-md-6"
          >
            <v-autocomplete
              v-model="formData.action_types"
              :label="actionTypeDetails.label"
              :items="actionTypeDetails.list"
              item-value="code"
              item-text="text"
              multiple
              small-chips
              deletable-chips
              clearable
              outlined
              dense
            />
          </div>

          <div class="col-12 py-0 col-md-6">
            <v-autocomplete
              v-model="formData.action_id"
              :label="actionNotificationDetails.label"
              :items="actionNotificationDetails.list"
              item-value="code"
              item-text="text"
              :multiple="actionNotificationDetails.isMultiple"
              :small-chips="actionNotificationDetails.isMultiple"
              :deletable-chips="actionNotificationDetails.isMultiple"
              clearable
              outlined
              dense
              :error-messages="action_idErrors"
              @blur="$v.formData.action_id.$touch()"
            />
          </div>

          <ActionsFilterSelector
            v-if="formData.action_type_id === 1"
            :selectedReportNotificationType="selectedReportNotificationType"
            :filters="filters"
          />

          <template v-if="selectedActionDetails?.timing">
            <div
              v-if="formData.action_id === 5"
              class="col-12 py-0 col-sm-4"
              :class="{
                'col-md-6':
                  formData.schedule_type === 2 && formData.action_id === 5,
              }"
            >
              <v-text-field
                v-model="formData.custom_day"
                :label="$t('custom_day')"
                dense
                outlined
                clearable
                hide-selected
              />
            </div>

            <div
              class="col-12 py-0 col-sm-6"
              :class="{
                'col-md-12':
                  formData.schedule_type === 2 && formData.action_id !== 5,
                'col-md-4':
                  formData.schedule_type !== 2 && formData.action_id === 5,
              }"
            >
              <v-autocomplete
                v-model="formData.schedule_type"
                :label="$t('schedule_type')"
                :items="serverData.schedule_types"
                item-text="text"
                item-value="index"
                dense
                outlined
                clearable
                hide-selected
                :error-messages="schedule_typeErrors"
                @blur="$v.formData.schedule_type.$touch()"
              />
            </div>

            <div
              v-if="formData.schedule_type === 2"
              class="col-12 py-0 col-md-6 mb-6"
            >
              <v-autocomplete
                v-model="formData.days"
                :label="$t('day')"
                item-text="text"
                item-value="index"
                :items="serverData.days"
                multiple
                small-chips
                deletable-chips
                clearable
                outlined
                dense
                :error-messages="daysErrors"
                @blur="$v.formData.days.$touch()"
              />
            </div>

            <div
              class="col-12 py-0 col-sm-6"
              :class="{
                'col-md-4':
                  formData.schedule_type !== 2 && formData.action_id === 5,
              }"
            >
              <v-menu
                ref="dateMenu"
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-top="200"
                :return-value.sync="formData.at"
                transition="scale-transition"
                offset-x
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formData.at"
                    :label="$t('time')"
                    prepend-inner-icon="mdi-clock-outline"
                    readonly
                    outlined
                    clearable
                    dense
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="atErrors"
                    @blur="$v.formData.at.$touch()"
                  />
                </template>
                <v-time-picker
                  format="24hr"
                  v-if="dateMenu"
                  v-model="formData.at"
                  full-width
                  @click:minute="$refs.dateMenu.save(formData.at)"
                ></v-time-picker>
              </v-menu>
            </div>
          </template>

          <div
            v-if="selectedActionDetails?.template"
            class="col-12 pb-0"
            :class="{
              'col-md-6':
                formData.action_type_id === 2 || formData.action_type_id === 3,
            }"
          >
            <v-autocomplete
              v-model="formData.template_id"
              :label="$t('template')"
              item-text="text"
              item-value="index"
              :items="serverData.templates"
              clearable
              outlined
              dense
              :error-messages="template_idErrors"
              @blur="$v.formData.template_id.$touch()"
            />
          </div>

          <div
            class="col-12"
            :class="{
              'col-md-6':
                formData.action_type_id === 2 &&
                formData.receiver_type === 'end_customer',
            }"
          >
            <v-file-input
              v-model="formData.logo"
              outlined
              :label="$t('logo')"
              clearable
              hide-details
              dense
              append-icon="mdi-camera"
              prepend-icon=""
            />
          </div>
        </div>

        <!--begin::Actions-->
        <div class="mb-4 mt-8 min d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light me-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            {{ submitButtonText }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import swalEdited from "@/core/services/AlertServices/SwalEdited";
import swalAdded from "@/core/services/AlertServices/SwalAdded";
import { SET_ACTIONS_DIALOG_SERVER_DATA } from "@/core/services/store/notifications.module";
import fieldValueValidation from "@/own/mixins/fieldValueValidation.js";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import { SET_FILTERS_DATA } from "@/core/services/store/filter.module";
import ActionsFilterSelector from "@/own/components/settings/notifications/ActionsFilterSelector.vue";

export default {
  name: "ActionsDialog",
  props: ["refresher", "pageLoader"],
  components: { ActionsFilterSelector, Multiselect },
  mixins: [validationMixin, fieldValueValidation],
  validations: {
    formData: {
      title: { required },
      receiver_type: { required },
      receiver_values: {
        required: requiredIf(function () {
          // return (
          //   this.formData.receiver_type !== "end_customer" &&
          //   this.formData.receiver_type !== "self"
          // );
          return (
            this.receiverDetails?.list?.length &&
            this.formData.receiver_type !== "self"
          );
        }),
      },
      action_type_id: { required },
      action_id: { required },
      // action_types: {
      //   required: requiredIf(function () {
      //     return (
      //       this.formData.action_type_id === 2 ||
      //       this.formData.action_type_id === 3
      //     );
      //   }),
      // },
      schedule_type: {
        required: requiredIf(function () {
          return this.formData.action_type_id === 1;
        }),
      },
      days: {
        required: requiredIf(function () {
          return this.formData.action_type_id === 1;
        }),
      },
      at: {
        required: requiredIf(function () {
          return this.formData.action_type_id === 1;
        }),
      },
      template_id: {
        required: requiredIf(function () {
          return (
            this.formData.action_type_id !== 1 &&
            this.selectedActionDetails?.template
          );
        }),
      },
    },
  },
  data: function () {
    return {
      dialog: false,
      ccFocused: false,
      bccFocused: false,
      dateMenu: null,
      formData: {
        title: null,
        receiver_type: null,
        cc_emails: [],
        bcc_emails: [],
        receiver_values: null, // type is Array for multiple select and integer for single
        action_type_id: null,
        action_types: [],
        action_id: null, // type is Array for multiple select and integer for single
        custom_day: null, // only available when is selected report notification => inventory expiry
        schedule_type: null, // Weekly, Daily, if selected daily show days input
        days: [1, 2, 3, 4, 5, 6, 7],
        at: "",
        template_id: null,
        logo: null,
      },
      disableWatchers: true,
      isForEdit: false,
      receiverDetails: {
        label: "Receiver",
        list: [],
        isMultiple: true,
        action_types: [],
      },
      actionTypeDetails: {
        label: "Action types",
        list: [],
      },
      actionNotificationDetails: {
        label: "Action",
        list: [],
        isMultiple: false,
      },
      ccOptions: [],
      bccOptions: [],
    };
  },
  methods: {
    resetCCEmails(type) {
      if (type === 1) {
        this.formData.cc_emails = [];
        this.ccOptions = [];
      } else if (type === 2) {
        this.formData.bcc_emails = [];
        this.bccOptions = [];
      }
    },
    addTag(newTag, type = "cc_emails", optionsType = "ccOptions") {
      newTag
        .trim()
        .replace(/,\s*/g, " ")
        .replace(/\s\s+/g, " ")
        .split(" ")
        .forEach((element) => {
          this[optionsType].push({
            name: element,
            code:
              element.substring(0, 2) + Math.floor(Math.random() * 10000000),
          });
          this.formData[type].push({
            name: element,
            code:
              element.substring(0, 2) + Math.floor(Math.random() * 10000000),
          });
        });

      setTimeout(() => {
        this.$refs[type].$el.focus();
      }, 100);
    },
    loadDataFromServer() {
      this.resetCCEmails(1);
      this.resetCCEmails(2);
      if (this.actionType) {
        let sendData = { id: this.$store.getters.getItemForAction.id };
        this.pageLoader(true);
        ApiService.post("/settings/notifications/edit", sendData)
          .then(({ data }) => {
            this.isForEdit = true;
            if (!this.serverData) {
              this.$store.commit(SET_ACTIONS_DIALOG_SERVER_DATA, data);
            }
            this.formData = {
              // id: sendData.id,
              ...data.notification,
              cc_emails: [],
              bcc_emails: [],
              action_type_id: data.notification.action_id,
              action_types: data.notification.action_types,
              action_id: [...data.notification.values],
            };

            if (data.notification.action_id === 1) {
              const receiverTypeDetails = data.receiver_types.find(
                (item) => item.value === data.notification.receiver_type
              );

              this.formData.action_id = [
                receiverTypeDetails.action_types.reports.find(
                  (item) => item.id === Number(data.notification.values[0])
                )?.code,
              ];
            }

            data.notification.cc_emails?.forEach((element) => {
              this.ccOptions.push({
                name: element,
                code:
                  element.substring(0, 2) +
                  Math.floor(Math.random() * 10000000),
              });
              this.formData.cc_emails.push({
                name: element,
                code:
                  element.substring(0, 2) +
                  Math.floor(Math.random() * 10000000),
              });
            });

            data.notification.bcc_emails?.forEach((element) => {
              this.bccOptions.push({
                name: element,
                code:
                  element.substring(0, 2) +
                  Math.floor(Math.random() * 10000000),
              });
              this.formData.bcc_emails.push({
                name: element,
                code:
                  element.substring(0, 2) +
                  Math.floor(Math.random() * 10000000),
              });
            });

            if (
              Array.isArray(data.notification.filters) &&
              data.notification.filters?.length
            ) {
              const filters = {};
              data.notification.filters.forEach((filter, index) => {
                if (Array.isArray(filter.value)) {
                  if (filter?.name === "high_value_shipment") {
                    if (!filters[filter.name]) {
                      filters[filter.name] = [];
                    }
                    filters[filter.name][index] = {
                      value: [...filter.value],
                      threshold: filter.threshold,
                    };
                  } else {
                    filters[`${filter.name}`] = [...filter.value];
                  }
                } else filters[`${filter.name}`] = filter.value;
              });

              this.$store.commit(SET_FILTERS_DATA, { ...filters });
            }

            this.disableWatchers = false;
            this.dialog = true;
          })
          .catch(() => {
            this.dialog = false;
          })
          .finally(() => {
            this.pageLoader(false);
          });
      } else {
        if (!this.serverData) {
          this.pageLoader(true);
          ApiService.post("/settings/notifications/create")
            .then(({ data }) => {
              this.isForEdit = false;
              this.$store.commit(SET_ACTIONS_DIALOG_SERVER_DATA, data);
              this.pageLoader(false);
            })
            .catch(() => {
              this.dialog = false;
              this.pageLoader(false);
            });
        }
        this.disableWatchers = false;
        this.dialog = true;
      }
    },
    toggleModal() {
      this.$store.commit(SET_FILTERS_DATA, {});
      if (this.dialog) {
        this.resetFormData();
        // this.dialog = !this.dialog;
        this.dialog = false;
      } else {
        this.loadDataFromServer();
      }
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));

        // if (fieldName === "at") {
        //   const regWithSeconds = RegExp(
        //     // eslint-disable-next-line
        //     /^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/
        //   );
        //   if (!regWithSeconds.test(this.formData.at)) {
        //     errors.push("Time have to be in 24h HH:MM or HH:MM:SS format");
        //   }
        // }
      }
      return errors;
    },
    convertToFormData() {
      // console.log(this.formData);
      let data = new FormData();
      Object.entries(this.formData).forEach((item) => {
        if ((item[1] && item[0] !== "logo") || item[1] === 0) {
          if (Array.isArray(item[1])) {
            item[1].forEach((it) => data.append(`${item[0]}[]`, it));
          } else if (
            typeof item[1] === "object" &&
            item[1] !== null &&
            !Array.isArray(item[1])
          ) {
            data.append(item[0], JSON.stringify(item[1]));
          } else {
            data.append(item[0], item[1]);
          }
        } else if (item[1] && item[0] === "logo") {
          data.append(item[0], item[1][0]);
        }
      });
      return data;
    },
    formatFilterData() {
      let men = [];
      let val = this.$store.getters.getFiltersData;

      Object.entries(val).forEach((filter) => {
        if (
          filter[0] != null &&
          filter[1] != null &&
          filter[1] != undefined &&
          filter[1].length !== 0
        ) {
          if (
            this.selectedReportNotificationType === "high_value_shipment" &&
            Array.isArray(filter[1])
          ) {
            filter[1].forEach((item) => {
              men.push({
                name: filter[0],
                value: [...item.value],
                threshold: item.threshold,
              });
            });
          } else men.push({ name: filter[0], value: filter[1] });
        }
      });

      return men;
    },
    submitForm() {
      // console.log("getFiltersData", this.formatFilterData());
      if (!this.selectedReceiverDetails) {
        Swal.fire({
          title: "Warning",
          text: "Please select receiver details",
          icon: "error",
          showConfirmButton: true,
          timer: 10000,
        });
        return;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      let formData = new FormData();
      formData.append("title", this.formData.title);
      this.formData.logo && formData.append("logo", this.formData.logo);
      formData.append("receiver_type", this.formData.receiver_type);
      if (
        this.receiverDetails?.list?.length &&
        this.formData.receiver_type !== "self"
      ) {
        formData.append(
          "receiver_values",
          JSON.stringify(this.formData.receiver_values)
        );
      }

      this.formData.cc_emails?.length &&
        formData.append(
          "cc_emails",
          JSON.stringify(this.formData.cc_emails.map((item) => item.name))
        );
      this.formData.bcc_emails?.length &&
        formData.append(
          "bcc_emails",
          JSON.stringify(this.formData.bcc_emails.map((item) => item.name))
        );
      //   this.formData.receiver_values.forEach((it) =>
      //     formData.append(`receiver_values[]`, it)
      //   );
      // }
      //
      // this.formData.cc_emails?.length &&
      //   this.formData.cc_emails.forEach((it) =>
      //     formData.append(`cc_emails[]`, it)
      //   );
      // this.formData.bcc_emails?.length &&
      //   this.formData.bcc_emails.forEach((it) =>
      //     formData.append(`bcc_emails[]`, it)
      //   );

      formData.append("action_id", this.formData.action_type_id);

      if (this.formData.action_type_id === 1) {
        this.formData.schedule_type &&
          formData.append("schedule_type", this.formData.schedule_type);
        this.formData.at && formData.append("at", this.formData.at);

        if (this.formData.schedule_type === 2) {
          this.formData.days?.length &&
            formData.append("days", JSON.stringify(this.formData.days));
          // this.formData.days.forEach((it) => formData.append(`days[]`, it));
        }

        if (this.formData.action_id === 5) {
          this.formData.custom_day &&
            formData.append("custom_day", this.formData.custom_day);
        }
      } else {
        this.formData.template_id &&
          formData.append("template_id", this.formData.template_id);
        this.formData.action_types?.length &&
          formData.append(
            "action_types",
            JSON.stringify(this.formData.action_types)
          );
        // this.formData.action_types.forEach((it) =>
        //   formData.append(`action_types[]`, it)
        // );
      }
      // actionNotificationDetails.list
      if (!this.actionNotificationDetails.isMultiple) {
        if (this.formData.action_type_id === 1) {
          formData.append(
            "values",
            JSON.stringify([
              this.actionNotificationDetails.list.find(
                (it) => it.code === this.formData.action_id
              )?.id,
            ])
          );
          // formData.append(
          //   `values[]`,
          //   this.actionNotificationDetails.list.find(
          //     (it) => it.code === this.formData.action_id
          //   )?.id
          // );
        } else {
          // formData.append(`values[]`, this.formData.action_id);
        }
      } else {
        formData.append("values", JSON.stringify(this.formData.action_id));
        // this.formData.action_id.forEach((it) =>
        //   formData.append(`values[]`, it)
        // );
      }

      let formattedFilters = this.formatFilterData();
      if (formattedFilters?.length) {
        formData.append("filters", JSON.stringify(formattedFilters));
        // formattedFilters.forEach((filter, index) =>
        //   formData.append(`filters[${index}][${filter.name}]`, filter.value)
        // );
      }

      let actionUrl = "store";
      if (this.actionType) {
        actionUrl = "update";
        formData.append("id", this.formData.id);
      }

      this.pageLoader(true);
      ApiService.post(`/settings/notifications/${actionUrl}`, formData)
        .then(() => {
          if (this.actionType) swalEdited();
          else swalAdded();
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    // before logo was added:
    // submitForm() {
    //   if (!this.selectedReceiverDetails) {
    //     Swal.fire({
    //       title: "Warning",
    //       text: "Please select receiver details",
    //       icon: "error",
    //       showConfirmButton: true,
    //       timer: 10000,
    //     });
    //     return;
    //   }
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    //   // if (this.$store.getters.isClient) delete this.formData.customer_id;
    //
    //   const payload = {
    //     title: this.formData.title,
    //     receiver_type: this.formData.receiver_type,
    //     cc_emails: this.formData.cc_emails.map((item) => item.name),
    //     bcc_emails: this.formData.bcc_emails.map((item) => item.name),
    //     // receiver_values:
    //     //   this.formData.receiver_type !== "end_customer" &&
    //     //   this.formData.receiver_type !== "self"
    //     //     ? this.formData.receiver_values
    //     //     : [],
    //     receiver_values:
    //       this.receiverDetails?.list?.length &&
    //       this.formData.receiver_type !== "self"
    //         ? this.formData.receiver_values
    //         : [],
    //     action_id: this.formData.action_type_id,
    //     values: this.formData.action_id,
    //     logo: this.formData.logo,
    //     // schedule_type: this.formData.schedule_type,
    //     // days: this.formData.days,
    //     // at: this.formData.at,
    //     // template_id: this.formData.template_id,
    //   };
    //
    //   if (this.formData.action_type_id === 1) {
    //     // payload.warehouses = this.formData.warehouses;
    //     payload.schedule_type = this.formData.schedule_type;
    //     payload.at = this.formData.at;
    //
    //     if (this.formData.schedule_type === 2) {
    //       payload.days = this.formData.days;
    //     }
    //
    //     if (this.formData.action_id === 5) {
    //       payload.custom_day = this.formData.custom_day;
    //     }
    //   } else {
    //     payload.template_id = this.formData.template_id;
    //     payload.action_types = this.formData.action_types;
    //   }
    //
    //   // if (this.formData.action_type_id === 1) {
    //   //   payload.values = this.formData.action_id;
    //   // }
    //   //   if (!this.receiverDetails.isMultiple) {
    //   //     payload.receiver_values = [this.formData.receiver_values];
    //   //   }
    //
    //   if (!this.actionNotificationDetails.isMultiple) {
    //     payload.values = [this.formData.action_id];
    //   }
    //   let actionUrl = "store";
    //   if (this.actionType) {
    //     actionUrl = "update";
    //     payload.id = this.formData.id;
    //   }
    //
    //   this.pageLoader(true);
    //   ApiService.post(`/settings/notifications/${actionUrl}`, payload)
    //     .then(() => {
    //       if (this.actionType) swalEdited();
    //       else swalAdded();
    //       this.toggleModal();
    //       this.refresher();
    //     })
    //     .catch(() => {
    //       this.pageLoader(false);
    //     });
    // },
    resetFormData() {
      this.formData = {
        title: null,
        // warehouses: [],
        receiver_type: null,
        cc_emails: [],
        bcc_emails: [],
        receiver_values: null,
        action_type_id: null,
        action_types: null,
        action_id: null,
        custom_day: null,
        schedule_type: null,
        days: [1, 2, 3, 4, 5, 6, 7],
        at: "",
        template_id: null,
        logo: null,
      };
      this.disableWatchers = true;
      this.isForEdit = false;
      this.receiverDetails = {
        label: "Receiver",
        list: [],
        isMultiple: true,
        action_types: [],
      };
      this.actionTypeDetails = {
        label: "Action types",
        list: [],
      };
      this.actionNotificationDetails = {
        label: "Action",
        list: [],
        isMultiple: false,
      };
    },
  },
  computed: {
    serverData: function () {
      return this.$store.getters.getNOTIFICATIONSActionsDialogServerData;
    },
    //if true, we are editing item, false we are adding
    actionType: function () {
      return !!this.$store.getters.getItemForAction;
    },
    submitButtonText: function () {
      if (this.actionType) return "Update";
      else return "Submit";
    },
    headerText: function () {
      if (this.actionType) return "Edit Item";
      else return "Add New Item";
    },
    titleErrors: function () {
      return this.handleFormValidation("title");
    },
    receiver_typeErrors: function () {
      return this.handleFormValidation("receiver_type");
    },
    receiver_valuesErrors: function () {
      return this.handleFormValidation("receiver_values");
    },
    action_type_idErrors: function () {
      return this.handleFormValidation("action_type_id");
    },
    // action_typesErrors: function () {
    //   return this.handleFormValidation("action_types");
    // },
    action_idErrors: function () {
      return this.handleFormValidation("action_id");
    },
    schedule_typeErrors: function () {
      return this.handleFormValidation("schedule_type");
    },
    daysErrors: function () {
      return this.handleFormValidation("days");
    },
    atErrors: function () {
      return this.handleFormValidation("at");
    },
    template_idErrors: function () {
      return this.handleFormValidation("template_id");
    },
    isClient() {
      return this.$store.getters.currentUser.data.is_client;
    },
    selectedReceiverType() {
      return this.formData.receiver_type;
    },
    selectedReceiverDetails() {
      return this.serverData.receiver_types.find(
        (item) => item.value === this.formData.receiver_type
      );
    },
    selectedActionType() {
      return this.formData.action_type_id;
    },
    selectedReportNotificationType() {
      return this.formData.action_id;
    },
    filters() {
      if (this.selectedActionType === 1) {
        return this.serverData.filters.find(
          (item) => item.code === this.selectedReportNotificationType
        )?.filters;
      } else return [];
    },
    selectedActionDetails() {
      return this.selectedReceiverDetails?.action_types?.actions.find(
        (item) => item.index === this.formData.action_type_id
      );
    },
  },
  watch: {
    // selectedReportNotificationType: function (newValue, oldValue) {
    //   if (!this.disableWatchers) {
    //     console.log("oldValue", oldValue);
    //     console.log("newValue", newValue);
    //     if (newValue && newValue !== oldValue) {
    //       this.$store.commit(SET_FILTERS_DATA, {});
    //     }
    //   }
    // },
    selectedReceiverType: function (newValue, oldValue) {
      // console.log("newValue selectedReceiverType", newValue);
      if (newValue && !this.disableWatchers) {
        if (newValue !== oldValue) {
          this.receiverDetails.label = this.selectedReceiverDetails.label;
          // this.receiverDetails.label = this.$t(
          //   this.selectedReceiverDetails.label
          // );

          if (this.selectedReceiverDetails.value === "end_customer") {
            this.receiverDetails.label = "Seller";
          }

          this.receiverDetails.list = this.selectedReceiverDetails.receivers;

          this.receiverDetails.action_types =
            this.selectedReceiverDetails.action_types.actions;

          if (!this.isForEdit) {
            this.formData.receiver_values = [];
          }
        }
      } else {
        this.receiverDetails = {
          label: "Receiver",
          list: [],
          isMultiple: true,
          action_types: [],
        };
      }
    },
    selectedActionType: function (newValue, oldValue) {
      // console.log("newValue selectedActionType", newValue);
      if (newValue && !this.disableWatchers) {
        if (newValue !== oldValue) {
          this.actionNotificationDetails.label =
            this.selectedActionDetails.text;
          if (newValue === 1) {
            this.formData.template_id = null;
            this.actionNotificationDetails.isMultiple = false;
            this.actionNotificationDetails.list =
              this.selectedReceiverDetails?.action_types.reports;

            // console.log("this.isForEdit", this.isForEdit);
            if (!this.isForEdit) {
              this.formData.action_id = null;
              this.formData.action_types = [];
            } else if (this.formData.action_id) {
              this.formData.action_id = this.formData.action_id[0];
            }
          } else {
            this.formData.days = [1, 2, 3, 4, 5, 6, 7];
            this.formData.at = "";
            this.actionNotificationDetails.isMultiple = true;
            if (!this.isForEdit) {
              this.formData.action_id = [];
              this.formData.action_types = [];
            }

            if (newValue === 2) {
              this.actionTypeDetails.label = "Order type";
              this.actionTypeDetails.list =
                this.selectedReceiverDetails?.action_types.order_types;
              this.actionNotificationDetails.list =
                this.selectedReceiverDetails?.action_types.order_statues;
            } else if (newValue === 3) {
              this.actionTypeDetails.label = "ASN type";
              this.actionTypeDetails.list =
                this.selectedReceiverDetails?.action_types.asn_types;
              this.actionNotificationDetails.list =
                this.selectedReceiverDetails?.action_types.asn_statuses;
            } else if (newValue === 4) {
              this.actionNotificationDetails.list =
                this.selectedReceiverDetails?.action_types.pickup_statuses;
            }
          }

          this.isForEdit = false;
        }
      } else {
        this.actionTypeDetails = {
          label: "Action types",
          list: [],
        };
        this.actionNotificationDetails = {
          label: "Action",
          list: [],
          isMultiple: false,
        };
      }
    },
  },
};
</script>
